import { createContext, useContext, useEffect, useState, type ReactNode } from 'react';
import { RADAR_LOCALES, type RadarLocale } from './radarLanding';
import { radarProductCopy } from './radarProduct';
import { preferredRadarLocale, saveRadarLocale } from './radarLocalePreference';

type Params = Record<string, string | number>;
export function radarText(locale: RadarLocale, source: string, params: Params = {}) {
  const entry = radarProductCopy[source];
  const text = locale === 'en' || !entry ? source : entry[locale === 'zh-Hans' ? 0 : 1];
  return text.replace(/\{(\w+)\}/g, (match, name) => String(params[name] ?? match));
}

const Context = createContext({ locale: 'en' as RadarLocale, setLocale: (_locale: RadarLocale) => {},
  e: (source: string) => source,
  t: (source: string, params?: Params) => radarText('en', source, params) });

export function RadarLocaleProvider({ children }: { children: ReactNode }) {
  const [locale, setLocaleState] = useState(preferredRadarLocale);
  function setLocale(next: RadarLocale) { saveRadarLocale(next); setLocaleState(next); }
  useEffect(() => {
    const previous = document.documentElement.lang;
    document.documentElement.lang = locale;
    return () => { document.documentElement.lang = previous; };
  }, [locale]);
  const e = (source: string) => !source ? '' : radarText(locale, locale === 'en' || radarProductCopy[source]
    ? source : 'Something went wrong. Please try again.');
  return <Context.Provider value={{ locale, setLocale, e, t: (source, params) => radarText(locale, source, params) }}>{children}</Context.Provider>;
}

export const useRadarLocale = () => useContext(Context);

export function RadarLanguagePicker() {
  const { locale, setLocale, t } = useRadarLocale();
  return <div className="radar-language-bar"><label>
    <span>{t('Language')}</span>
    <select aria-label={t('Language')} value={locale} onChange={event => setLocale(event.target.value as RadarLocale)}>
      {RADAR_LOCALES.map(item => <option key={item.locale} value={item.locale}>{item.label}</option>)}
    </select>
  </label></div>;
}
